import React from 'react';

import './LoginView.css';
// import nielsenLogo from "../../../img/logo2.gif";

const LoginView = (props) => {
  return(
    <div className="row featured-home">
      <div id="login_form">
        <div className="login_tit">
          <span className="login_tit_txt">Buzzword Login</span>
        </div>
        <div id="login_body">	
          <table align="center" border="0" cellpadding="0" cellspacing="0">
            <tr>
              <td className="login_purple_line"></td>
            </tr>
            <tr>
              <td valign="top" className="login">
                <table width="350" border="0" align="center" cellpadding="7" cellspacing="0">
                  <tr>
                    <td width="80" align="right"><strong>아이디 :</strong></td>
                    <td width="155"><input type="text" className="box" id="loginid" name="loginid" style={{"width": "150px"}} value={props.email} onChange={props.handleEmailInput}/></td>
                    <td width="110" rowspan="2" valign="middle">
                      <span id='button_area'>
                        <button className="button loginBtn" style={{border:"none"}} onClick={props.handleLogin}>로그인</button>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td align="right"><strong>비밀번호 :</strong></td>
                    <td><input type="password" className="box" id="loginpw" name="loginpw" style={{"width":"150px"}} value={props.password} onChange={props.handlePasswordInput} onKeyPress={props.handleOnKeyPress}/></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td className="login">
                <ul className="login_notice">
                  <li className="login_notice">※ 본 사이트는 Chrome, Firefox, Safari 브라우저에 최적화되어 있습니다. Internet Explorer 브라우저를 지원하지 않습니다.</li>
                  <li className="login_notice">※ 로그인이 안되시면, <a href="mailto:buzz@koreanclick.com" style={{color: "#5a6372"}}>buzz@koreanclick.com</a> 으로 문의하시기 바랍니다.</li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div style={{height: "700px"}}></div>
    </div>
  )
}

export default LoginView;